import { useEffect, useState } from 'react';

const UbicationUser = () => {
    const [userLocation, setUserLocation] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!navigator.geolocation) {
            setError('Geolocalización no es soportada por tu navegador.');
            return;
        }

        const success = (position) => {
            const { latitude, longitude } = position.coords;
            setUserLocation({ lat: latitude, lon: longitude });
        };

        const error = () => {
            setError('No se pudo obtener la ubicación.');
        };

        navigator.geolocation.getCurrentPosition(success, error);
    }, []);

    return { userLocation, error };
};

export default UbicationUser;